// src/pages/MaintenancePage.js
import React from 'react';

{/**
    * 1. Modern & Professional (Recommended)
    * Best for a general update. It is direct and uses clean Chinese.
    * Heading: System Maintenance in Progress | 系統維護中
    * EN: We are currently performing scheduled maintenance to improve our services. We’ll be back online shortly.
    * 中文： 為提升服務質素，系統現正進行定期維護。我們將盡快恢復運作，不便之處，敬請原諒。
    * Action: Check back soon! | 請稍後再試！
    * 2. Feature-Focused (Exciting)
    * Best if you are launching the new Note (記事) or GBR/BBR features you just created!
    * Heading: Upgrading for You | 正在為您升級
    * EN: We are adding new features to help you manage your home better. DoneDaily will be back in a moment!
    * 中文： 我們正更新系統功能，務求為您提供更好的家務管理體驗。${config.brand} 快將回歸！
    * Action: Stay tuned! | 敬請期待！
*/}
const MaintenancePage = () => {
    const brandColor = '#007bff'; // Matches your current blue

    return (
        <div style={styles.overlay}>
        <div style={styles.card}>
            {/* Animated Icon Container */}
            <div style={styles.iconWrapper}>
            <div style={{ ...styles.pulse, backgroundColor: brandColor }}></div>
            <span style={styles.icon}>🛠️</span>
            </div>

            <h1 style={{ ...styles.heading, color: brandColor }}>
            系統維護中 <span style={styles.divider}>|</span> System Maintenance
            </h1>

            <div style={styles.contentSection}>
            <p style={styles.chineseText}>
                為提升服務質素，系統現正進行定期維護。<br />
                我們將盡快恢復運作，不便之處，敬請原諒。
            </p>
            <p style={styles.englishText}>
                We are performing scheduled maintenance to improve our services.<br />
                We’ll be back online shortly. Thank you for your patience.
            </p>
            </div>

            <div style={styles.footer}>
            <p style={styles.actionText}>請稍後再試！ Check back soon!</p>
            </div>
        </div>
        </div>
    );
    };

    const styles = {
        overlay: {
            height: '100vh',
            width: '100vw',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#f8f9fa', // Light professional grey
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        },
        card: {
            maxWidth: '500px',
            width: '90%',
            padding: '40px 20px',
            backgroundColor: '#ffffff',
            borderRadius: '16px',
            boxShadow: '0 10px 25px rgba(0,0,0,0.05)',
            textAlign: 'center',
        },
        iconWrapper: {
            position: 'relative',
            display: 'inline-block',
            marginBottom: '20px',
        },
        icon: {
            fontSize: '40px',
            position: 'relative',
            zIndex: 2,
        },
        pulse: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '60px',
            height: '60px',
            borderRadius: '50%',
            opacity: 0.2,
            animation: 'pulse 2s infinite ease-in-out',
        },
        heading: {
            fontSize: '22px',
            fontWeight: '700',
            marginBottom: '24px',
            letterSpacing: '-0.5px',
        },
        divider: {
            color: '#dee2e6',
            fontWeight: '300',
            margin: '0 8px',
        },
        contentSection: {
            lineHeight: '1.6',
            color: '#495057',
        },
        chineseText: {
            fontSize: '16px',
            fontWeight: '500',
            marginBottom: '16px',
        },
        englishText: {
            fontSize: '14px',
            color: '#6c757d',
            marginBottom: '20px',
        },
        footer: {
            marginTop: '30px',
            paddingTop: '20px',
            borderTop: '1px solid #f1f3f5',
        },
        actionText: {
            fontSize: '14px',
            fontWeight: '600',
            color: '#adb5bd',
        }
    };

export default MaintenancePage;